module.exports = __webpack_public_path__ + "static/media/anthroarche.e9a9666b.jpg";